
















































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import { CartState } from "@/store/states/CartState";
import shopItemRawDefinitions from "@/assets/shop-items-definitions.json";
import { ValidationProvider } from "vee-validate";
import axios from "axios";
import { MetaInfo } from "vue-meta";
import { Debounce } from "vue-debounce-decorator";

@Component<Checkout>({
  components: {
    ValidationProvider,
  },
  metaInfo(): MetaInfo {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      title: "SWISS ECO BAGS ™ | " + (this as any).$i18n.t("appbar.shop"),
      meta: [
        {
          vmid: "description",
          name: "description",
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          content: (this as any).$i18n.t("shop.description"),
        },
      ],
    };
  },
})
export default class Checkout extends Vue {
  @State("cart") cart: CartState;
  @Getter("quantity", { namespace: "cart" }) quantity: number;
  @Getter("price", { namespace: "cart" }) price: number;
  @Action("loadOrCreateShopItem", { namespace: "cart" })
  loadOrCreateShopItem: Function;
  @Action("reset", { namespace: "cart" })
  reset: Function;
  @Action("saveContact", { namespace: "cart" })
  saveContact: Function;

  private productUUID = "999f6c2e-ae8f-4b8d-98bf-0a7b8d7eebae";
  public sameDeliveryAddress = true;
  public readonly titles = ["checkout.title.mr", "checkout.title.mrs"];
  public promocode = "";
  public promocodeValue = {
    percentage: 0,
    amount: 0,
  };
  // public readonly countries = [
  //   "checkout.country.switzerland",
  //   "checkout.country.france",
  //   "checkout.country.germany",
  //   "checkout.country.italy",
  // ];

  get itemTotalPrice() {
    return this.quantity * this.price;
  }

  get packagingPrice() {
    return shopItemRawDefinitions.prices.packaging;
  }

  get sendingPrice() {
    return shopItemRawDefinitions.prices.sending;
  }

  get contact() {
    return this.cart.contact;
  }

  get subtotal() {
    return this.itemTotalPrice + this.packagingPrice + this.sendingPrice;
  }

  get promotionPercentageAmount() {
    return (this.subtotal * (this.promocodeValue.percentage/100));
  }

  get promotionPercentageSubtotal() {
    return this.subtotal - this.promotionPercentageAmount
  }

  get vat() {
    return this.promotionPercentageSubtotal * 0.077;
  }

  get total() {
    return (this.promotionPercentageSubtotal + this.vat) - this.promocodeValue.amount;
  }

  @Debounce(500)
  checkCode() {
    axios
      .post(process.env.VUE_APP_BACKEND_URL + "/code", {
        code: this.promocode,
      })
      .then((response) => {
        this.promocodeValue = response.data;
      });
  }

  onContactChange() {
    this.saveContact(this.contact);
  }

  onSubmit() {
    axios
      .post(
        process.env.VUE_APP_BACKEND_URL + "/checkout/" + this.cart.current.uuid,
        {
          contact: this.cart.contact,
          summary: this.selectedOptionTranslated,
          quantity: this.quantity,
          locale: this.$i18n.locale,
          promocode: this.promocode
        }
      )
      .then((response) => {
        if (process.env.VUE_APP_PAYREXX === "bypass") {
          axios.post(process.env.VUE_APP_BACKEND_URL + "/payment_webhook", {
            transaction: {
              id: 1,
              uuid: null,
              amount: 10000,
              referenceId: null,
              time: "2020-08-14 16:37:14",
              status: "confirmed",
              lang: "fr",
              psp: "",
              pspId: 1,
              mode: "TEST",
              metadata: [],
              invoice: {
                number: "123456",
                products: [
                  {
                    name: 123456,
                    price: 100,
                    quantity: 1,
                    sku: null,
                    vatRate: null,
                  },
                ],
                amount: 10000,
                discount: {
                  code: null,
                  amount: 0,
                  percentage: null,
                },
                shippingAmount: null,
                currency: "CHF",
                test: 1,
                referenceId: this.cart.current.uuid,
                paymentRequestId: null,
                paymentLink: null,
              },
              subscription: null,
              pageUuid: null,
              payment: {
                brand: null,
              },
            },
          });
        } else {
          this.$router.push({
            name: "Payment",
            params: { payrexxUrl: response.data["url"] },
          });
        }
      });
  }

  created() {
    // In case of a reload
    if (this.cart.current === undefined) {
      this.loadOrCreateShopItem(this.productUUID);
    }
    // if (this.cart.contact.country === "") {
    //   this.cart.contact.country = this.$i18n.t(this.countries[0]) as string;
    // }
    // if (this.cart.contact.delivery.country === "") {
    //   this.cart.contact.delivery.country = this.$i18n.t(
    //     this.countries[0]
    //   ) as string;
    // }
  }

  get selectedOptionTranslated() {
    return Array.from(this.selectedOptionTranslationKeys.values(), (v) =>
      this.$i18n.t(v)
    ).join(", ");
  }

  get selectedOptionTranslationKeys() {
    const result: string[] = [];
    if (this.cart.current) {
      // Name of the product
      shopItemRawDefinitions.items.forEach((item) => {
        if (item.uuid === this.cart.current.itemDefinitionUuid) {
          result.push(item.nameTranslationKey);
        }
      });
      // Selected options (only multiple choice for the moment)
      Object.keys(this.cart.current.itemOptions).forEach(
        (selectedOptionUUID) => {
          shopItemRawDefinitions.options.forEach((option) => {
            if (selectedOptionUUID === option.uuid) {
              if (option.type === "multipleChoice") {
                const selectedChoiceUUID = Object.keys(
                  this.cart.current.itemOptions[selectedOptionUUID]
                )[0];
                option.options.forEach((choice) => {
                  if (choice.uuid === selectedChoiceUUID) {
                    result.push(choice.nameTranslationKey);
                  }
                });
              }
            }
          });
        }
      );
    }
    return result;
  }

  get thumbnail() {
    let result = "";
    if (this.cart.current) {
      Object.keys(this.cart.current.itemOptions).forEach(
        (selectedOptionUUID) => {
          shopItemRawDefinitions.options.forEach((option) => {
            if (
              selectedOptionUUID === option.uuid &&
              option.checkoutThumbnail
            ) {
              const selectedThumbnailUUID = Object.keys(
                this.cart.current.itemOptions[selectedOptionUUID]
              )[0];
              option.options.forEach((choice) => {
                if (choice.uuid === selectedThumbnailUUID) {
                  result = choice.thumbnail;
                }
              });
            }
          });
        }
      );
    }
    return result;
  }
}
